module.exports = {"TXTCLI_OK":{"id":"TXTCLI_OK","defaultMessage":"ОК","flags":["TRACK"],"track":"OK"}}